import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ConverterService,
  InterceptorUtil,
  LoggerService,
  Occ,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  normalizeHttpError,
} from '@spartacus/core';
import { ORDER_NORMALIZER, Order } from '@spartacus/order/root';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CheckOrderAdapter } from './check-order.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccCheckOrderAdapter implements CheckOrderAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  checkOrder(orderId: string): Observable<boolean> {
    const url = this.occEndpoints.buildUrl('orderExists', { urlParams: { orderId } });

    let headers = new HttpHeaders();

    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http
      .get<boolean>(url, { headers })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  getOrder(orderId: string): Observable<Order> {
    const url = this.occEndpoints.buildUrl('orderDetails', { urlParams: { orderId } });

    let headers = new HttpHeaders();

    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http.get<Occ.Order>(url, { headers }).pipe(this.converter.pipeable(ORDER_NORMALIZER));
  }
}
